export { default } from './OpenContestSection';
